import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
//import CloseIcon from '@material-ui/icons/Close';
import { Button, Chip, IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import BillingIcon from '@material-ui/icons/AttachMoney';
import PaymentIcon from '@material-ui/icons/Payment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { Grid, GridColumn, GridColumnMenuFilter } from "@progress/kendo-react-grid";
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import Breadcrumbs from '../core/controls/components/breadcrumbs';
import DefaultSettings from '../core/controls/components/settings';
import { GetData } from '../core/controls/helpers/requests.js';
import { createRequest, requestApi } from '../core/controls/helpers/rest.js';
import KendoChart from '../modules/chart/kendochart.js';
import { getEnvVariable } from '../modules/environmentalList.js';
import InvoiceSideBar from './billinginvoice.js';
import { RequestPayOnline } from './billingservice';
import YearDropdown from './YearDropdown';
import MSBCheckout from './onlinepay/msbcheckout.js';
import Dropdown from '../core/controls/components/dropdown.js';
const _ = require('lodash');

const drawerWidth = 840;



const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1, 1, 0, 0),
    marginRight: theme.spacing(1000000),
  },
  drawerPaper: {
    width: drawerWidth,
  },
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));


const extraProps = {
  transformProps: {
    label: 'Name',
    value: 'Id'
  },
}

function BillingDashboard(props, ref) {
  const [open, setOpen] = useState(false);
  const [sitepermittype, setsitepermittype] = useState(null);
  const [sitepermittypeitems, setsitepermittypeitems] = useState();
  const [year, setyear] = useState(2023);
  const [column, setColumn] = useState([]);
  const [id, setId] = useState(1);
  const [amountPaid, setamountPaid] = useState(null);
  const [amountPending, setamountPending] = useState(null);
  const [totalAmount, settotalAmount] = useState(null);
  const [amountOverdue, setamountOverdue] = useState(null);
  const [total, setTotal] = useState(null)
  const [OpenInvoice, setOpenInvoice] = useState(false);
  const [quarters, setquarters] = useState([]);
  //  const[datagridcol,setdatagricol]=useState([]);
  const [gridSelectionRecord, setGridSelectionRecord] = useState(false)
  const [chartSeries, setchartSeries] = useState(null);
  const [fileContent, setFileContent] = useState({ htmlFileContent: '<span>Loading Invoice Details</span>' });
  const classes = useStyles();
  const [dataState, setDataState] = useState({ skip: 0, take: 20 })
  const [columns, setColumns] = useState([])
  const [filteredfield, setFilteredField] = useState([])
  const [reload, setReload] = useState(false)
  const [datacheck, setdatacheck] = useState([])

  // add one array and set all quater data based on index
  //ex: const allquater, setallquater = useState([]) 
  const [griddata, setGriddata] = useState([])
  const [totalchartSeries, setTotalChartSeries] = useState([])
  const [totalformatchart, setTotalFormatChart] = useState([])
  //const [q2chartSeries, setQ2ChartSeries] = useState([])
  //const [q3chartSeries, setQ3ChartSeries] = useState([])
  //const [q4chartSeries, setQ4ChartSeries] = useState([])
  const [style, setStyle] = useState("dark");
  const [style1, setStyle1] = useState("dark");
  const [cardItems, setCardItems] = useState([])
  const [pieformatdata, setPieFormatData] = useState([])
  const [invoiceType, setInvoiceType] = useState('Application Invoice')
  const [openMSBPay, setOpenMSBPay] = useState(false)

  // const [selectData, setselectData] = useState([])
  const [data, setData] = useState()
  const [pageable, setPageable] = useState({
    buttonCount: 2,
    info: true,
    type: 'numeric',
    pageSizes: [10, 20, 30, 40, 50, "All"],
    previousNext: true,
  })
  const datakeys = getEnvVariable('ModuleKey') === 'ECCO' ? 'invoicePaidCount,invoiceUnpaidCount' : 'invoicePaidCount,invoiceUnpaidCount,transactionProcessingCount,transactionCompletedCount'
  // const pieformatdata = {
  //   "sitePermitTypeId": 1,
  //   "invoicePaidCount": 31,
  //   "invoiceUnpaidCount": 26,
  //   "transactionProcessingCount": 10,
  //   "transactionCompletedCount": 22
  // }
  const datakeylabels = ['Paid', 'Unpaid', 'Processing', 'Completed']
  const [type, setType] = useState('')

  const _export = useRef(null)
  let gridDataState = { ...dataState, take: pageable.pageSizes.includes(dataState['take']) ? dataState.take : "All" }
  let gridPageable = { ...pageable, ['info']: pageable.pageSizes.includes(dataState['take']) && typeof (dataState['take']) == 'number' ? true : false }

  useEffect(() => {
    setOpen(props.open);
    const currentYear = new Date().getFullYear();
    setyear(currentYear);

    const read = [
      {
        url: getEnvVariable('AdminConfig') + `/api/SitePermitTypes/SubModuleKey/Active`,
        type: 'get'
      },


    ]
    Promise.all(read.map(each => requestApi(createRequest(each, {})))).then(response => {
      let [list1] = response;
      if(getEnvVariable('ModuleKey') === 'ECCO') {
        list1 = list1.filter(e => e.IsInvoiced === 'Y');
        list1.unshift({ Id: -1, Name: 'All', IsDefault : 'Y' }) 
      }
      setsitepermittypeitems(list1);
      getDefaultSitePermitType(list1);


    })

  }, []);

  useEffect(() => {
    getchartdata(invoiceType);
  }, [sitepermittype, year]);

  const chartLegendName = (name) => {
    name = name.toLowerCase().replaceAll("_", " ")
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  const breadcrumbs = {
    type: 'breadcrumbs',
    items: [
      invoiceType === "Application Invoice" ? { "link": "Invoice Dashboard / Application Invoice", "materialicon": "assessment", className: 'breadcrumb-item text-dark', class: 'text-dark' } :
        { "link": "Invoice Dashboard / Renewal Invoice", "materialicon": "assessment", className: 'breadcrumb-item text-dark', class: 'text-dark' }
    ],
  }

  const formatPieChartData = (data) => {
    let result = [];

    let keylabels = datakeys
    if (data && keylabels != '') {
      let keys = keylabels.split(',');
      if (keys && keys.length > 0) {
        keys.map((element, index) => {
          result.push({
            "share": data[element],
            "kind": datakeylabels[index]
          })
        })
      }

    }
    return result
  }


  const InvoiceType = (griddata1, val = '') => {
    let grid = griddata1.data
    let data = {}
    if ((val === 'Application Invoice')) {  //&& grid && grid.length > 0
      data = grid.filter(e => e.InvoiceType === 'Application Invoice')
      setStyle("contained")
      setStyle1("outlined")
      setGriddata(data)
    }
    else {
      data = grid.filter(e => e.InvoiceType === 'PermitRenewal Invoice')
      setStyle1("contained")
      setStyle("outlined")
      setGriddata(data)
    }
  }


  const getchartdata = (invoiceType, dataState = null) => {
    const queryStr = dataState != null &&  `${toDataSourceRequestString(dataState)}`; 
    if (sitepermittype && year) {
      const read2 = [
        {
          url: getEnvVariable('Payment') + `InvoiceDashboard/All/` + `${sitepermittype}` + '/' + `${year}` + '/' + `${invoiceType}` + `?${queryStr}`,
          type: 'get'
        },
        {
          url: getEnvVariable('Payment') + `InvoiceDashboard/AllInvoicesGrid/` + `${sitepermittype}` + '/' + `${year}` + '/' + `${invoiceType}`+`?${queryStr}`,
          type: 'get'
        },
        {
          url: getEnvVariable('Payment') + `InvoiceDashboard/IncoiceStatus/` + `${sitepermittype}` + '/' + `${year}` + '/' + `${invoiceType}`+`?${queryStr}`,
          type: 'get'
        },
      ]

      console.log('sitepermittypesitepermittype', sitepermittype);
      Promise.all(read2.map(each => requestApi(createRequest(each, {})))).then(response => {
        const [list2, list3, list4] = response;
        setamountPaid(list2.amountPaid);
        setamountPending(list2.amountPending);
        settotalAmount(list2.totalAmount);
        setTotal(list3.total);
        setamountOverdue(list2.amountOverdue);
        setquarters(list2.chartHeader);
        modifychartseries(list2.chartSeries, list2.chartHeader);
        setPieFormatData(list4);
        //formatPieChartData(pieformatdata)
        setdatacheck(list3);
        if (list3) {
          InvoiceType(list3, invoiceType)
        }
        if (list2) {
          let avoidkeys = ['chartHeader', 'chartSeries', 'sitePermitTypeId', 'amountOverdue']
          let carditems = []
          Object.keys(list2).forEach(e => {
            if (!avoidkeys.includes(e)) {
              carditems.push({ [e]: list2[e] })
            }
          })
          console.log(carditems)
          setCardItems(carditems)
        }
        console.log(chartSeries);

      })
    }
  }

  const onColumnsSubmit = (columnsState) => {
    setColumns(columnsState)
  }
  const handleFieldChange = (event) => {
    const { name, value } = event.target
    if (name === 'SITE_PERMIT_TYPE_ID') {
      setsitepermittype(value);
    }

  }

  const getDefaultSitePermitType = (res) => {
    let defaultsitepermittypeid = ''
    if (res && res.length > 0) {
      let defaultvalue = _.find(res, { 'IsDefault': 'Y' });
      defaultsitepermittypeid = defaultvalue ? defaultvalue.Id : ''
      setsitepermittype(defaultsitepermittypeid);
      console.log(sitepermittype);

    }
  }

  const handleIconClick = (invoice) => {
    if (invoice && invoice.Id > 0) {
      let downloadid = invoice.InvoiceType == 'Application Invoice' ? invoice.ApplicationInvoiceDownloadId : invoice.PermitInvoiceDownloadId;
      let gridselectionrecord = { InvoiceId: invoice.Id, DownloadId: downloadid, ...invoice }
      setOpenInvoice(true);
      setGridSelectionRecord(gridselectionrecord)
    }
  }

  const handleEditIconClick = (invoice) => {
    let id = invoice.RefId;
    let SitepermitTypeId = invoice.SitepermitTypeId;
    let SitepermitTypeKey = (getEnvVariable('ModuleKey') === 'LAOACS' && invoice.SitepermitTypeId === 1)? "APPLICATIONS" :  invoice.SitepermitTypeId == 1 ? "UTILITY" : invoice.SitepermitTypeId == 2 ? "OSOW" : invoice.SitepermitTypeId == 3 ? "ACCESS" : invoice.SitepermitTypeId == 4 ? "ROW" : invoice.SitepermitTypeId == 6 ? "ATV" : "APPLICATIONS"
    let paramid = invoice.InvoiceType === 'Application Invoice' ? '0' : '2'
    if (invoice && invoice.Id > 0) {
      let queryURL = '#/Records/' + SitepermitTypeKey + '/' + SitepermitTypeId + '/' + id + '/billings/' + paramid;
      window.open(queryURL, '_blank');
    }
  }

  // Add click handler to navigate to an applicant/record page. Uses ApplicantId, falls back to RefId or Id.
  const handleApplicantClick = (dataItem) => {
    const applicantId = dataItem.ApplicantId;
    if (!applicantId) return;
    // Construct a URL - adjust the path to match your routing if needed
    const url = `#/Administration/companies/${applicantId}`;
    window.open(url, '_blank');
  }

  const handlePayClick = (invoice) => {
    if (invoice && invoice.Id > 0) {
      if(getEnvVariable('ModuleKey') === 'ECCO'){
        setGridSelectionRecord(invoice)
        openMSBPayDailogue(true)
      }else{
        RequestPayOnline(invoice.Id).then(res => {
          if (res && res.htmL5RedirectUrl) {
            payOnlineRequester(res.htmL5RedirectUrl)
          }
        })
      }
    }
  }

  const payOnlineRequester = (url) => {
    let payment_window = window.open(url, 'popUpWindow', 'height=800,width=1400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
    payment_window.focus();
    var timer = setInterval(function () {
      if (payment_window.closed) {
        clearInterval(timer);
        getchartdata(invoiceType);
        //LoadExistingInvoiceData();
      } else {
        try {
          if (payment_window?.location?.href && payment_window.location.href !== url) {
            console.log('URL changed:', payment_window.location.href);
            payment_window.close();
            DefaultSettings.getAlert().show('Payment successful.', 'info');
            //url = payment_window.location.href;
          }
        } catch (e) {
          // Can't access URL, not same domain
        }
      }
    }.bind(this), 2000);
  }

  const handleInvoiceSlider = () => {
    setOpenInvoice(false);
    setGridSelectionRecord(false);
  }

  const kendofilterdata = (eventData) => {
    let queryParam = `${toDataSourceRequestString(eventData.dataState)}`;
    queryParam = queryParam.replace(/ /g, "__SPACE__")
    const url = getEnvVariable('Payment') + `InvoiceDashboard/AllInvoicesGrid/` + `${sitepermittype}` + '/' + `${year}`;
    // const url = getEnvVariable('Report') + `/api/ReportQuery/DashboardNotifications`;

    let body = {}
    const queryStr = queryParam != null ? `${url}?${queryParam}` : `${url}`
    GetData(queryStr, body, true).then(resp => {
      setdatacheck(resp);
    });
  }
  const handleDataStateChange=(event)=>{
    const { childGrid } = window.location.href
    if(event.filter && event.filter.length > 0){
      kendofilterdata(event)
    }
    setDataState(event.dataState);
    getchartdata(invoiceType,event.dataState)
    
  }
  const handleDate = (event) => {
    let newDate = event.dataItem[event.field];
    if(newDate){
      return <td>{moment(newDate).format('MM/DD/YYYY')}</td>
    } 
}

  const rowRender = (trElement, props) => {
    //const available = props.dataItem;
    // const green = {
    //   backgroundColor: "rgb(128, 128, 128,0.32)", //"#4CAF50"//
    // };
    // const red = {
    //   backgroundColor: "rgb(225, 225, 225, 0.32)", //"#F44336"//"
    // };
    // const trProps = {
    //   style: available.Status === "Paid" ? green : red,
    // };
    return React.cloneElement(
      // trElement,
      // {

      //   ...trProps,
      // },
      trElement.props.children
    );
  };


  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('lg'));

  const getCardSize = () => {
    if (isLg) return { width: '124%', height: '80px' };
    if (isXl) return { width: '116%', height: '80px' };
    return { width: '100%', height: '100px' };
  };

  const getrowSize = () => {
    if (isLg) return { width: '31%' };
    if (isXl) return { width: '32%' };
    return { width: '31%' };
  };

  const cardSize = getCardSize();
  const rowSize = getrowSize();


  const statusCell = (event) => {
    const val = event.dataItem[event.field]
    const bgcolor = val === 'Paid' ? 'rgba(185, 246, 202, 0.376)' : 'rgba(251, 233, 231, 0.5)'; // Change as needed
    const color = val === 'Paid' ? 'rgb(0, 200, 83)' : val === 'Unpaid' ? 'rgb(216, 67, 21)' : 'rgb(255, 87, 34)'
    return <td > <Chip size='small' style={{ backgroundColor: bgcolor, color: color }} label={val} /></td>
  }

  const statusTranCell = (event) => {
    const val = event.dataItem[event.field]
    const bgcolor = val === 'Completed' ? 'rgba(185, 246, 202, 0.376)' : 'rgba(251, 233, 231, 0.5)'; // Change as needed
    const color = val === 'Completed' ? 'rgb(0, 200, 83)' : 'rgb(216, 67, 21)'
    return <td > <Chip size='small' style={{ backgroundColor: bgcolor, color: color }} label={val} /></td>
  }

  const buttonDisable = (invoice) => {
    return invoice.Status === "Paid" || invoice.Status === "Cancelled" 
  }

  const handleExport = (action) => {
    const read = [{
      url: getEnvVariable('Payment') + `InvoiceDashboard/AllInvoicesGrid/` + `${sitepermittype}` + '/' + `${year}`,
      type: 'get',
    }]
    let excelDataState = dataState;
    if (action === 'filterall')
      excelDataState['take'] = total
    let queryStr = `${toDataSourceRequestString(excelDataState)}`;
    let request = [{
      url: getEnvVariable('Payment') + `InvoiceDashboard/AllInvoicesGrid/` + `${sitepermittype}` + '/' + `${year}` + `?${queryStr}`,
      type: 'get',

    }]

    Promise.all(request.map(each => requestApi(createRequest(each, {})))).then(response => {
      const [results] = response;

      if (results && results.data && results.data.length > 0) {
        results.data.map(res => {
          if (res.CreatedOn) {
            res.CreatedOn = res.CreatedOn !== null ? moment(res.CreatedOn).format('MM/DD/YYYY hh:mm:ss A') : ""
          }
          if (res.UpdatedOn) {
            res.UpdatedOn = res.UpdatedOn !== null ? moment(res.UpdatedOn).format('MM/DD/YYYY hh:mm:ss A') : ""
          }
          if (res.IsFinal) {
            res.IsFinal = (res && res.IsFinal && res.IsFinal) === 'Y' ? "Yes" : "No"
          }
        })
        // let cols = columns.filter(each => !colList.includes(each['field']))
        _export.current.save(results.data);
      }

      //    setIsExport(false)
    }).catch(ex => {
      console.log(ex)
    })

  }






  const modifychartseries = (chartSeries, chartHeader) => {
    var totalseries = []
    let paidseries = chartSeries['paid'];
    let unpaidseries = chartSeries['unPaid']
    let completedseries = chartSeries['completed']
    let processingseries = chartSeries['processing']
    Object.keys(chartHeader).forEach(e => {
      let series = [
        {
          "share": paidseries[e],
          "kind": "Paid",
          "color": "#66bb6a"//"#DAF7A6"
        },
        {
          "share": unpaidseries[e],
          "kind": "Unpaid",
          "color": "#ef5350"//"#FF7F7F"
        },
        {
          "share": processingseries[e],
          "kind": "Processing",
          "color": "#42a5f5"//"#40CFFF"
        },
        {
          "share": completedseries[e],
          "kind": "Completed",
          "color": "#ab47bc"//"#C70039"
        }
      ]
      if (e === '0') {
        totalseries = series
      }
    })


    // const series = [
    //   {
    //     name: "Paid",
    //     data: paidseries,
    //   },
    //   {
    //     name: "Un Paid",
    //     data: unpaidseries,
    //   },
    //   {
    //     name: "Total",
    //     data: totalseries,
    //   },
    // ];
    //console.log(series);



    //  push all quaters info in to on array -- setallquater.push(seriesq1)
    //ex : key : object
    // Q1 : seriesQ1
    // Q2 : seriesQ2;
    //setQ3ChartSeries(seriesQ3);
    //setQ4ChartSeries(seriesQ4);
    setTotalChartSeries(totalseries);
    console.log(chartSeries);
  }
  const handleInvoiceType = (val) => {
    setInvoiceType(val)
    getchartdata(val);
    //InvoiceType(datacheck, val)
  }
  const handleYearSelect = (year) => {
    setyear(year);

  };
  const headerProps = {
    title: "Invoice",
    actions: [
      {
        type: 'menu',
        icon: 'excel',
        name: 'excel',
        color: 'primary',
        title: 'Export to Excel',
        menucolor: '#c90685',
        hideon: 'excel',
        hidevalue: false,
        items: [{
          name: 'Export Current Page',
          action: 'filtercurrent'
        },
        {
          name: 'Export All Pages',
          action: 'filterall'
        }
        ]
      },

    ]
  }
  const handlesetType = (typechange) => {
    if (typechange != type) {
      setType(typechange)
    }
  }

  const openMSBPayDailogue = (ref) => {
    setOpenMSBPay(ref)
    if(!ref){
    getchartdata(invoiceType);
    }
  }


  return (
    <div>
      <div className='col application-border'>
        <div>
          <div className='d-flex application-border mx-1 my-2'>
            <Breadcrumbs {...breadcrumbs} className="p-2 flex-grow-1">
            </Breadcrumbs>
            {/*<div className="p-2">
              <Button variant={style} color='primary' style={{ "height": "30px" }} align="center" onClick={() => openMSBPayDailogue(true)}>
                MSB Online Test button
              </Button>
            </div>*/}
            {getEnvVariable('ModuleKey') === 'ECCO' ? ( <div className="my-2 mx-1">
              <label style={{"font-family": "inherit", "font-weight": "600", "font-size": "14px"}}>Permit Type :</label>
            </div>) : ('')}
            {getEnvVariable('ModuleKey') === 'ECCO' ? (<div className="col-2 mx-2">
               <Dropdown extraProps={extraProps} items={sitepermittypeitems || []}  value ={sitepermittype} handleFieldValue={handleFieldChange}  label='Billing Site Permit Type'  name='SITE_PERMIT_TYPE_ID' />
            </div>) : ('')}
            <div className="my-2 mx-1">
              <label style={{"font-family": "inherit", "font-weight": "600", "font-size": "14px"}}>Year :</label>
            </div>
            <div className="mt-2 mx-2">
              <YearDropdown className="billingyear" onSelect={handleYearSelect} name='YEAR' />
            </div>
            {getEnvVariable('ModuleKey') === 'LAOACS' ? (<div className="p-2">
              <Button variant={style} color='primary' style={{ "height": "30px" }} align="center" onClick={() => handleInvoiceType('Application Invoice')}>
                Application Invoice
              </Button>
            </div> ) : ('')}
            {getEnvVariable('ModuleKey') === 'LAOACS' ? (<div className="p-2">
              <Button variant={style1} color='primary' style={{ "height": "30px" }} align="center" onClick={() => handleInvoiceType('PermitRenewal Invoice')}>
                Renewal Invoice
              </Button>
            </div>) : ('')}
            <div className="p-2">
              <label className="border" style={{ "height": "30px", borderRadius: '8px', backgroundColor: '#EDE7F6', textAlign: "Center", width: "125PX", fontWeight: "500", color: '#42a5f5'}} >
                Total : {parseFloat(totalAmount).toFixed(2)}
              </label>
            </div>
            <div className="p-2">
              <label className="border" style={{ "height": "30px", borderRadius: '8px', backgroundColor: '#EDE7F6', textAlign: "Center", width: "125PX", fontWeight: "500", color: '#66bb6a' }} >
                Paid : {parseFloat(amountPaid).toFixed(2)}
              </label>
            </div>
            <div className="p-2">
              <label className="border" style={{ "height": "30px", borderRadius: '8px', backgroundColor: '#EDE7F6', textAlign: "Center", width: "150PX", fontWeight: "500", color : '#ef5350' }} >
                Unpaid : {parseFloat(amountPending).toFixed(2)}
              </label>
            </div>
            {/* <div className="p-2">
              <Badge badgeContent={parseFloat(totalAmount).toFixed(2)} max={1000000000000} color="primary">
                  <Fab size="small" color="secondory" aria-label="Total Amount" title="Total Amount"><TotalIcon fontSize="small" /></Fab>
              </Badge>
            </div>
            <div className="p-2">
              <Badge badgeContent={parseFloat(amountPaid).toFixed(2)} max={1000000000000} color="secondary">
                  <Fab size="small" color="secondory" aria-label="Paid Amount" title="Paid Amount"><Paidicon fontSize="small" /></Fab>
              </Badge>
            </div>
            <div className="p-2">
              <Badge badgeContent={parseFloat(amountPending).toFixed(2)} max={1000000000000} color="error">
                  <Fab size="small" color="secondory" aria-label="Unpaid Amount" title="Unpaid Amount"><UnpaidOffIcon fontSize="small" /></Fab>
              </Badge>
            </div> */}
          </div>
        </div>
      </div>
      <div className='application-border mb-1'>
        <div className="d-flex application-border my-2 p-1">
          <div className="row col-3 mx-1" style={{ height: 'calc(94vh - 140px)', overflow: 'auto' }}>
            {/* <div className="row" style={{padding:'1px'}}>        
                {cardItems && cardItems.length > 0 && cardItems.map((item, index) => {
                const key = Object.keys(item)[0];
                let tempkey =  key === 'amountPaid' ? 'Paid' : key === 'amountPending' ? 'Unpaid' : 'Total'
                let tempcolor =  key === 'amountPaid' ? '#66bb6a' : key === 'amountPending' ? '#ef5350' : '#42a5f5'
                const value = item[key]; 
                  return (
                    <div className="md-1" style={{ width: rowSize.width}}>
                    <Card variant="soft" style={{ width: cardSize.width, height: cardSize.height , backgroundColor : tempcolor}}>
                    <CardContent size={'small'} key={index}>
                      <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 10 }}>
                        {tempkey}
                      </Typography>
                      <Typography variant="h7">
                        {parseFloat(value).toFixed(2)}
                      </Typography>
                    </CardContent>
                    </Card>
                    </div>
                  );
                })}    
            </div> */}
            <div className="border">
              {totalchartSeries && totalchartSeries.length > 0 && <div>
                <KendoChart data={totalchartSeries} />
              </div>
              }
            </div>
            <div className="border">
              {totalchartSeries && totalchartSeries.length > 0 && <div>
                <KendoChart item={pieformatdata} data={formatPieChartData(pieformatdata)} showToggles={true} />
              </div>
              }
            </div>
          </div>
          <div className="col-9 application-border mx-1">
            <div className="col-12" style={{ height: 'calc(94vh - 140px)', width: '99%', overflow: 'auto' }}>
              <Grid
                reorderable
                total={total}
                data={griddata}
                {...gridDataState}
                selection={true}
                columnMenu={GridColumnMenuFilter}
                onDataStateChange={handleDataStateChange}
                pageable={{
                  buttonCount: 2,
                  info: true,
                  type: 'numeric',
                  pageSizes: [10, 20, 30, 40, 50, 100],
                  previousNext: true
                }}
                style={{ height: 'calc(94vh - 140px)', overflow: 'auto', lineHeight: '14px' }}
                resizable
              //rowRender={rowRender}
              >
                <GridColumn field='View' title='Download' width="125px"
                  cell={(props) => (
                    <td>
                      <IconButton>
                        <VisibilityIcon onClick={() => handleIconClick(props.dataItem)}
                          style={{ cursor: 'pointer', color: '#30699f' }}
                        />
                      </IconButton>
                    </td>
                  )}

                />
                <GridColumn field='Billing' title='View Invoice' width="140px"
                  cell={(props) => (
                    <td>
                      <IconButton>
                        <BillingIcon onClick={() => handleEditIconClick(props.dataItem)}
                          style={{ cursor: 'pointer', color: '#30699f' }}
                        />
                      </IconButton>
                    </td>
                  )}

                />
                <GridColumn field='Pay' title='Pay Online' width="125px"
                  cell={(props) => (
                    <td>
                      <IconButton disabled={buttonDisable(props.dataItem)} title='Pay Online'>
                        <PaymentIcon onClick={() => handlePayClick(props.dataItem)}
                          style={{ cursor: 'pointer', color: '#097969' }}
                        />
                      </IconButton>

                    </td>
                  )}

                />
                {invoiceType === "Application Invoice" ? <GridColumn field="TrackingNumber" title="Tracking Number" width="180px" /> : ''}
                <GridColumn field="Id" title="Invoice Id" width="130px" />
                <GridColumn field="Status" title="Status" width="100px" cell={statusCell} />
                <GridColumn field="PaymentDateFormat" title="Payment Date" width="150px"/>
                {getEnvVariable('ModuleKey') === 'ECCO' ? <GridColumn field="SitePermitTypeName" title="Permit Type" width="150px" /> : ''}
                {invoiceType === "PermitRenewal Invoice" ? <GridColumn field="LineItemsCount" title="Line Items" width="125px" /> : ''}
                {getEnvVariable('AccessPortal') === 'I' ? (
                  <GridColumn field="Applicant" title="Applicant" width="200px"
                    cell={(props) => (
                      <td>
                        <a
                          href={`#/Administration/companies/${props.dataItem.ApplicantId || props.dataItem.RefId || props.dataItem.Id}`}
                          onClick={(e) => { e.preventDefault(); handleApplicantClick(props.dataItem); }}
                          style={{ cursor: 'pointer', color: '#30699f', textDecoration: 'underline' }}
                        >
                          {props.dataItem && props.dataItem.Applicant ? props.dataItem.Applicant : ''}
                        </a>
                      </td>
                    )} />
                ) : (<GridColumn field="Applicant" title="Applicant" width="200px" />)}
                {getEnvVariable('ModuleKey') === 'LAOACS' ? <GridColumn field="TransactionStatus" title="Transaction Status" width="180px" cell={statusTranCell} /> : ''}
                <GridColumn field="InvoiceType" title="Invoice Type" width="150px" />
                <GridColumn field="TotalAmount" title="Total Fee" width="150px" format="{0:0.00}" />
                <GridColumn field="AmountPending" title="Amount Due" width="150px" format="{0:0.00}" />
                <GridColumn field="AmountPaid" title="Amount Paid" width="150px" format="{0:0.00}" />
                <GridColumn field="TransactionFee" title="Processing Fee" width="150px" format="{0:0.00}" />
                <GridColumn field="InvoiceDate" title="Invoice Date" width="150px" cell={handleDate} />
                {getEnvVariable('ModuleKey') === 'LAOACS' ? <GridColumn field="DueDate" title="Invoice Due Date" width="150px" cell={handleDate} /> : <GridColumn field="PaymentDate" title="Due Upon Receipt Date" width="200px" cell={handleDate} />}
                <GridColumn field="NoOfpayments" title="No Of Payments" width="150px" />
                <GridColumn field="CheckNumbers" title="Check Numbers" width="150px" />
                <GridColumn field="RefId" title="Record Id" width="100px" />
                <GridColumn field="ApplicantId" title="Applicant Id" width="100px" />
              </Grid>


            </div>
            {/* <div className='row'>
         <KendoColumnChart categories={quarters} series={chartSeries}/>
        </div> */}
          </div>
        </div>
      </div>





      {OpenInvoice &&
        <InvoiceSideBar open={OpenInvoice} gridrow={gridSelectionRecord} handleInvoiceSlider={handleInvoiceSlider} />


      }

      {openMSBPay && <MSBCheckout open={openMSBPay} setOpen = {() => openMSBPayDailogue(false)} invoice={gridSelectionRecord} />}

    </div>

  );


}

export default forwardRef(BillingDashboard);
